stepperHeadings:
  chooseUsers: Medewerker(s) selecteren
  selectDateTimeRange: Periode selecteren
  addComment: Optionele opmerkingen
actions:
  back: Terug
  createAbsence: Afwezigheid opslaan
labels:
  allUsers: Alle medewerkers
  backTo: Terug naar {name}
  about: Voor
  date: Datum
  time: Tijd
  fullDay: Hele dag
fields:
  startDate: Datum
  startTime: Vanaf
  endTime: Tot
  endDate: Einddatum
  isFullDay: Hele dag
  comment: Opmerking
messages:
  chooseUsers: Voor wie geldt deze afwezigheid?
  selectDateTimeRange: Kies de periode voor afwezigheid.
  addComment: Voeg eventuele opmerkingen toe voor deze afwezigheid.
  absenceForAllUsers: Afwezigheid geldt voor iedereen
  specificUsers: Selecteer specifieke medewerkers
